import * as React from 'react'
import Icon from '../Icon/Icon'
import uuidv4 from 'uuid/v4'

export interface IDrinkNumberProps {
  label: string
  icon: string
  dosage: string
  onClickMinusButton: any
  inputValue: number
  onClickPlusButton: any
  onInputChange: any
  onClick: any
  onBlur: any
}

const DrinkNumber = ({
  label,
  icon,
  dosage,
  onClickMinusButton,
  inputValue,
  onClickPlusButton,
  onInputChange,
  onClick,
  onBlur,
}: IDrinkNumberProps) => {
  const id = uuidv4()

  return (
    <li className="DrinkNumber">
      <Icon name={icon} />
      <label htmlFor={`drink-${id}`} className="DrinkNumber-label">
        <span>{label}</span> <span>{dosage}</span>
      </label>

      <div className="DrinkNumber-buttons">
        <button
          type="button"
          onClick={onClickMinusButton}
          disabled={inputValue === 0 ? true : false}
          tabIndex={-1}
        >
          -
        </button>
        <input
          type="number"
          value={'' + inputValue}
          onChange={onInputChange}
          onClick={onClick}
          onBlur={onBlur}
          min="0"
          max="10"
          id={`drink-${id}`}
        />
        <button
          type="button"
          onClick={onClickPlusButton}
          disabled={inputValue === 10 ? true : false}
          tabIndex={-1}
        >
          +
        </button>
      </div>
    </li>
  )
}

export default DrinkNumber



// WEBPACK FOOTER //
// ./src/components/DrinkNumber/DrinkNumber.tsx